import React from 'react';
import {ADMIN_ROLE, ERROR_TYPES} from '../../constants/global';
import './index.scss';
//data is an array
const submitModalTable = ({modalData, id}) => {
  return(
    <div className='submitModal_table'>
      <table id={id?'submitModal_table_'+id:'submitModal_table'} className='cb-table cb-table-striped cb-table-condensed'>
        <thead>
          <tr>
            {
              ['Module Title', 'Question', 'Error/Issue'].map((head, index) => <th scope='col' className='tableheadernonadmin' 
              id={id? `subhd${id}${index}`:`subhd${index}id`} key={id? `subhd${id}${index}`:`subhd${index}id`}>{head}</th>)
            }
          </tr>
        </thead>
        <tbody>
          {
          modalData?.map((catdata, index) => (
            <tr key={`mod${index}key`} id={id? `subhd${id}${index}tr`:`subhd${index}idtr`}>
              <td key={`subbd${catdata.module_name}key`}>{catdata.module_name}</td>
              <td key={`d${catdata.module_name}key`}>{catdata.question_group_title} <br />{catdata.question_text}</td>
              <td key={`bbd${index}key`}>
                {
                    catdata.validationErrors?.map((el, index2) => <ol style={{listStyle: 'square'}} key={el+index2}><li style={{marginLeft: '-20px'}}>{el}</li></ol>)
                }
              </td>
            </tr>
          ))
          }
        </tbody>
      </table>
    </div>
  );
};

export const ValidationTable = ({modalData, role}) => {
  return(
    <div className='submitModal_table_secondone'>
      <table tabIndex={0} summary="please see errors below" id='submitModal_table_secondone' className='cb-table cb-table-striped cb-table-condensed'>
        <thead>
          <tr>
            {
              ['Status', 'Error/Issue', 'Module Title', 'Question'].map((head, index) => <th style={{backgroundColor:' white'}} scope='col' className='tableheadernonadmin' id={`subhdsc${index}id`} key={`subhdsc${index}id`}>{head}</th>)
            }
          </tr>
        </thead>
        <tbody>
          {
          modalData?.map((catdata, index) => (
            <tr key={`mod${index}key`} id={`subbdsc${index}id`}>
              <td key={`status${index}key`}>{catdata.validation_type===ERROR_TYPES.SIMPLE?<span style={{color: 'red'}}>Required</span>:(
                catdata.validation_type===ERROR_TYPES.COMPLEX?(
                  role===ADMIN_ROLE?<span style={{color: 'red'}}>Required</span>:<span style={{color: 'black'}}>Warning</span>
                ):null
              )}</td>
              <td key={`error${index}key`}>
                {
                      catdata.validationErrors?.map((el, index2) => <ol style={{listStyle: 'square', listStyleType:'none'}} key={el+index2}><li style={{marginLeft: '-40px'}}>{el}</li></ol>)
                  }
              </td>
              <td key={`moduletitle${index}key`}>
                {catdata.module_name}
              </td>
              <td key={`question${index}key`}>{catdata.question_group_title} <br />{catdata.question_text}</td>
            </tr>
          ))
          }
        </tbody>
      </table>
    </div>
  );
};

export default submitModalTable;